import { Schema, NodeSpec } from 'prosemirror-model'

const nodes = {
  doc: {
    content: 'heading*',
  } as NodeSpec,

  text: {
    group: 'inline',
  } as NodeSpec,

  heading: {
    content: 'inline*',
    group: 'block',
    attrs: {
      level: { default: 2 },
    },
    toDOM: ({ attrs }) => [`h${attrs.level}`, 0],
    parseDOM: [
      {
        tag: 'h2,h3',
        getAttrs: (node: Node) => ({
          level: parseInt(node.nodeName.charAt(1)),
        }),
      },
    ],
  } as NodeSpec,
}

const marks = {}

export const schema = new Schema({ nodes, marks })
